export default {"src":"/_next/static/media/pink.44a49547.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};